import { FormEvent, useMemo, useState } from 'react'
import { legacyHolidayRows, legacyHolidayYears, type LegacyHolidayRow } from '../../mock/legacyHoliday'
import './LegacyHoliday.css'

function openHolidayPopup(mode: 'add' | 'update', year: string, row?: LegacyHolidayRow) {
  const query = new URLSearchParams({ CRUD: mode === 'add' ? '1' : '2', year })
  if (row) {
    query.set('holiday_id', row.id)
    query.set('holiday_date', row.date.replaceAll('-', ''))
    query.set('holiday_name', row.name)
    query.set('holiday_yn', row.isHoliday ? '1' : '2')
    query.set('holiday_memo', row.memo)
  }
  window.open(`/v1/system/holiday/popup?${query}`, `system_holiday_popup_${mode}`, 'width=560,height=360')
}

export function LegacyHolidayManagement() {
  const [year, setYear] = useState('2026')
  const [searched, setSearched] = useState(false)
  const [apiAdded, setApiAdded] = useState(false)
  const [notice, setNotice] = useState('')
  const rows = useMemo(() => searched ? [...legacyHolidayRows, ...(apiAdded ? [{ id: 'mock-holiday-api', date: '2026-10-03', day: '토', name: 'Mock API 공휴일', isHoliday: true, memo: '공공데이터 Mock 결과' }] : [])] : [], [apiAdded, searched])

  const submit = (event: FormEvent) => {
    event.preventDefault()
    window.history.replaceState({}, '', `${location.pathname}?year=${year}`)
    setSearched(true)
    setNotice(`${year}년 비식별 Mock 공휴일을 조회했습니다.`)
  }

  return <div className="legacy-y02">
    <h1 className="g_title">공휴일 관리</h1>
    <div className="l_system_holiday_setting_page_wrap">
      <div className="l_system_holiday_form_wrap">
        <form className="l_system_holiday_form" onSubmit={submit}>
          <div className="g_filter_wrap">
            <div className="g_row"><div className="g_input_wrap"><label className="g_label title center" htmlFor="l_year_select">년도</label><select className="g_input" name="year" id="l_year_select" value={year} onChange={(event) => setYear(event.target.value)}>{legacyHolidayYears.map((value) => <option key={value}>{value}</option>)}</select></div></div>
            <div className="g_row"><button type="submit" className="g_btn search g_btn_submit l_holiday_submit_btn">검색</button></div>
          </div>
        </form>
      </div>
      <div className="l_system_holiday_list_wrap">
        <div className="g_list_wrap no_scroll">
          <table className="g_list l_system_holiday_data_list">
            <colgroup><col style={{ width: 50 }} /><col style={{ width: 120 }} /><col style={{ width: 60 }} /><col style={{ width: 200 }} /><col style={{ width: 120 }} /><col /></colgroup>
            <thead><tr><th>no</th><th>일자</th><th>요일</th><th>공휴일명</th><th>휴일여부</th><th>비고</th></tr></thead>
            <tbody>{rows.length ? rows.map((row, index) => <tr key={row.id} onClick={() => openHolidayPopup('update', year, row)}><td><button type="button">{index + 1}</button></td><td>{row.date}</td><td>{row.day}</td><td>{row.name}</td><td>{row.isHoliday ? '휴일' : '휴일 아님'}</td><td>{row.memo}</td></tr>) : <tr className="l_help_tr"><td className="l_msg_td" colSpan={6}>검색해주세요.</td></tr>}</tbody>
          </table>
        </div>
        <div className="l_system_holiday_list_function_wrap"><div className="g_row"><button className="g_btn add l_holiday_popup" type="button" disabled={!searched} onClick={() => openHolidayPopup('add', year)}>추가</button><button className="g_btn add l_get_holiday" type="button" disabled={!searched} onClick={() => { setApiAdded(true); setNotice('공휴일 API 가져오기를 Mock 데이터로 처리했습니다.') }}>공휴일 API 가져오기</button></div></div>
      </div>
    </div>
    {notice && <div className="legacy-y02__notice" role="status">{notice}<button type="button" onClick={() => setNotice('')}>×</button></div>}
  </div>
}

export function LegacyHolidayPopup() {
  const query = new URLSearchParams(window.location.search)
  const update = query.get('CRUD') === '2'
  const year = query.get('year') || '2026'
  const [date, setDate] = useState(update ? `${query.get('holiday_date')?.slice(0, 4)}-${query.get('holiday_date')?.slice(4, 6)}-${query.get('holiday_date')?.slice(6, 8)}` : '')
  const [name, setName] = useState(update ? query.get('holiday_name') || '' : '')
  const [holidayYn, setHolidayYn] = useState(query.get('holiday_yn') || '1')
  const [memo, setMemo] = useState(update ? query.get('holiday_memo') || '' : '')
  const [notice, setNotice] = useState('')

  const action = (event: FormEvent, type: 'save' | 'modify') => {
    event.preventDefault()
    if (!date || !name) {
      setNotice('일자와 공휴일명을 입력해주세요.')
      return
    }
    setNotice(`공휴일 ${type === 'save' ? '저장' : '수정'}을 Mock 처리했습니다.`)
  }

  return <main className="main_wrapper g_main_content l_system_holiday_popup legacy-y02-popup">
    <h1 className="g_title">공휴일 {update ? '수정' : '등록'}</h1>
    <div className="l_system_holiday_setting_popup_page_wrap">
      <div className="g_card l_system_holiday_popup_form_wrap">
        <form className="l_system_holiday_popup_form" id="l_system_holiday_popup_form" onSubmit={(event) => action(event, update ? 'modify' : 'save')}>
          <input className="l_hidden" name="holiday_id" value={query.get('holiday_id') || ''} readOnly />
          <div className="g_row"><div className="g_input_wrap required"><label className="g_label title center">일자</label><input aria-label="일자" className="g_input width_2x" placeholder={`${year}-MM-DD`} value={date} onChange={(event) => setDate(event.target.value)} /></div><p className="l_curr_day_str" /></div>
          <div className="g_row"><div className="g_input_wrap required"><label className="g_label title center">공휴일명</label><input aria-label="공휴일명" className="g_input width_2x" value={name} onChange={(event) => setName(event.target.value)} /></div></div>
          <div className="g_row"><div className="g_input_wrap required"><label className="g_label title center">휴일여부</label></div><div className="g_input_wrap l_radiobox_wrap"><input className="g_input g_radiobox" type="radio" name="holiday_yn" id="l_holiday" value="1" checked={holidayYn === '1'} onChange={(event) => setHolidayYn(event.target.value)} /><label htmlFor="l_holiday">휴일</label></div><div className="g_input_wrap l_radiobox_wrap"><input className="g_input g_radiobox" type="radio" name="holiday_yn" id="l_unholiday" value="2" checked={holidayYn === '2'} onChange={(event) => setHolidayYn(event.target.value)} /><label htmlFor="l_unholiday">휴일아님</label></div></div>
          <div className="g_row"><div className="g_input_wrap"><label className="g_label title center">비고</label><input aria-label="비고" className="g_input width_2x" value={memo} onChange={(event) => setMemo(event.target.value)} /></div></div>
          <div className="g_row l_system_holiday_popup_function_wrap">{update ? <><button className="g_btn modify" type="submit">수정</button><button className="g_btn delete" type="button" onClick={() => setNotice('공휴일 삭제를 Mock 처리했습니다.')}>삭제</button></> : <button className="g_btn save" type="submit">저장</button>}</div>
        </form>
      </div>
    </div>
    {notice && <div className="legacy-y02-popup__notice" role="status">{notice}</div>}
  </main>
}
